module.exports = __webpack_public_path__ + "static/media/questionnaire.22ec5e15.svg";